<ng-container *ngIf="showAlways || unread > 0">
  <hk-wc-icon
    name="chat"
    [size]="iconSize"
    [class.text--primary]="displayPrimary"
  ></hk-wc-icon>
  <span
    *ngIf="unread > 0 && isFirstVisitForCustomer"
    class="unread-indicator text--no-wrap"
  >
    {{ unread }}
  </span>
</ng-container>
